import { render } from "./CouponComponent.vue?vue&type=template&id=bf51b24c"
import script from "./CouponComponent.vue?vue&type=script&lang=js"
export * from "./CouponComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/coupons/CouponComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf51b24c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf51b24c', __exports__)) {
    api.reload('bf51b24c', __exports__)
  }
  
  module.hot.accept("./CouponComponent.vue?vue&type=template&id=bf51b24c", () => {
    api.rerender('bf51b24c', render)
  })

}


export default __exports__